import { z } from 'zod';

import type { ConvertedPackage } from '$lib/package';

export const MapMetadataSchema = z.object({
  file_id: z.string().optional(),
  location_id: z.string().optional(),
  file_url: z.string().optional(),
  robot_id: z.string().optional(),
  robot_name: z.string().optional(),
  module: z.string().optional(),
  module_version: z.string().optional(),
});

export type MapMetadata = z.infer<typeof MapMetadataSchema>;

export type ConvertedMapPackage = ConvertedPackage<MapMetadata>;
